/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import { veiculoStoreChassi } from "../../../hooks/store";

import { LayoutConsultaVeiculo } from "./LayoutConsultaVeiculo";
import { ResultadoConsultaVeiculoPlaca } from "../../../components";

type InputProps = {
  chassiVeiculo: string;
};

export const ConsultaVeiculoChassi: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      chassiVeiculo: "",
    },
  });
  const history = useHistory();
  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 8 ? s.url : false;
  })[0];

  const {
    consultaVeiculoChassi,
    mensagemVeiculoChassi,
    resultadoVeiculoChassi,
    limparConsultaVeiculoChassi,
  } = veiculoStoreChassi((state) => state.veiculo);

  const { loading } = veiculoStoreChassi((state) => state.global);

  const PesquisaChassiVeiculo = (data: InputProps) => {
    consultaVeiculoChassi(url, data.chassiVeiculo);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  const handleRedirectInfo = () => {
    return history.push("/consulta-veiculo/ficha-veiculo", {
      dados: resultadoVeiculoChassi,
    });
  };

  return (
    <LayoutConsultaVeiculo>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(PesquisaChassiVeiculo)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="chassiVeiculo"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o Chassi"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaVeiculoChassi}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoVeiculoChassi || mensagemVeiculoChassi ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoVeiculoChassi && (
            <ResultadoConsultaVeiculoPlaca
              nome={resultadoVeiculoChassi.Nome}
              placa={resultadoVeiculoChassi.Placa}
              chassi={resultadoVeiculoChassi.Chassi}
              onClick={() => handleRedirectInfo()}
            />
          )) || (
            <MUI.Typography variant="h6">
              {mensagemVeiculoChassi}
            </MUI.Typography>
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaVeiculo>
  );
};
